(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__videoGuideReady) return;
    window.__videoGuideReady = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.video-guide__play');
      if (!button) return;
      var player = button.closest('[data-video-guide]');
      if (!player || player.querySelector('iframe')) return;

      var id = encodeURIComponent(player.getAttribute('data-video-id'));
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title = player.getAttribute('data-video-title') || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      button.replaceWith(iframe);
      iframe.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
